import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { HeaderHelpers } from '../../service/HeaderHelpers/HeaderHelpers';
import { Lang, Tld } from '../../typings/common';
import { Loader } from '../Loader/Loader';

import './Tableau.css';

interface TableauProps {
    lang: Lang;
    domain: Tld;
}

interface TableauState {
    isLoading: boolean;
}

const tableauLink = 'https://yastatic.net/tableau/tableau.html?service-id=direct';

export class Tableau extends React.Component<TableauProps, TableauState> {
    constructor(props: TableauProps) {
        super(props);

        this.state = {
            isLoading: true
        };
    }

    render() {
        const { isLoading } = this.state;
        const { lang, domain } = this.props;
        const services = HeaderHelpers.getTableauServices(lang).join('+');

        return (
            <div className={Bem.cls('tableau', 'container')}>
                {isLoading && <Loader size={'m'} />}
                <iframe
                    className={Bem.cls('tableau', 'iframe', {
                        hidden: isLoading
                    })}
                    frameBorder="0"
                    src={`${tableauLink}&services=${services}&lang=${lang}&domain=${domain}`}
                    onLoad={this.onLoad}
                />
            </div>
        );
    }

    private onLoad = () => this.setState({ isLoading: false });
}
